<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,

  props: {
    labels: {
      type: Array,
      required: true
    },
    datasets: {
      type: Object,
      required: true
    },
    viewsColor: {
      type: String,
      required: true,
    },
    interactionsColor: {
      type: String,
      required: true,
    },
    avgInteractionsColor: {
      type: String,
      required: true,
    },
    displayTitle: {
      type: Boolean,
      default: true
    }
  },

  mounted () {
    this.renderChart({
      labels: this.labels,
      datasets: [
        {
          label: this.$t('Views'),
          borderColor: this.viewsColor,
          backgroundColor: this.viewsColor,
          fill: false,
          data: this.datasets.views
        },
        {
          label: this.$t('Interactions'),
          borderColor: this.interactionsColor,
          backgroundColor: this.interactionsColor,
          fill: false,
          data: this.datasets.interactions
        },
      ]
    }, {
      title: {
        display: this.displayTitle,
        text: this.$t('Last 30 days'),
        fontSize: 14,
        fontFamily: 'Roboto',
        fontStyle: 'normal'
      },
    })
  }
}
</script>